import moment from "moment";

export const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });

// dueDate vem como string "YYYY-MM-DD…" — corta antes de parsear para não
// deslocar o dia por fuso horário
export const formatDate = (value) =>
  value ? moment(String(value).substring(0, 10)).format("DD/MM/YYYY") : "-";

export const formatDateTime = (value) =>
  value ? moment(value).format("DD/MM/YYYY HH:mm") : "-";
